import React from 'react'
import { NextPage } from 'next'
import {
  StorefrontEventWithProducts,
  getEvent
} from '@/modules/event/getEvent'
import StorePage from '@/modules/shared/components/StorePage'

type EventPageProps = {
  event: StorefrontEventWithProducts
}

const EventPage: NextPage<EventPageProps> = (props: EventPageProps) => {

  const { event } = props

  return (
    <StorePage
      event={event}
      prefix={'EventPage'}
    />
  )
}

export default EventPage

export async function getServerSideProps(context): Promise<any> {
  const { eventId } = context.params
  const eventData = await getEvent(eventId)

  const products = eventData.products
          .filter(product => product.availableInStorefront)

  const event = {
    ...eventData,
    products: products
  }

  if (!event) {
    return {
      notFound: true
    }
  }
  return {
    props: {
      event
    },
  }
}
